/** @jsx jsx */
import { jsx } from "theme-ui"

import Text from "./text"

const Modal = ({ title, children, onClose, customStyle }) => {
  return (
    <div
      sx={{
        position: "fixed",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        height: "100%",
        top: 0,
        left: 0,
        p: [0, 0, 0, 5],
        background: "rgba(0,0,0,0.5)",
        zIndex: 9999,
      }}
    >
      <div
        sx={{
          width: "100%",
          // height: "100%",
          // px: [0, 0, 0, "30px"],
          // pt: "20px",
          pb: 6,
          background: "#fff",
          boxShadow: "0px 0px 8px 0px rgba(0, 0, 0, 0.43)",
          ...customStyle,
        }}
      >
        <div
          sx={{
            display: "flex",
            justifyContent: "space-between",
            // mb: 3,
            // mx: ["20px", "20px", "20px", 0],
          }}
        >
          <Text type="h3">{title || ""}</Text>
          <Text
            type="h3"
            customStyle={{ color: "primary", cursor: "pointer" }}
            {...(onClose && { onClick: onClose })}
          >
            &#10005;
          </Text>
        </div>

        <div sx={{ width: "100%", height: "100%", overflow: "auto" }}>
          {children}
        </div>
      </div>
    </div>
  )
}

export default Modal
